export default "__VITE_ASSET__sbt4f41P__"